export default __webpack_public_path__ + "static/media/img11.08bd4cb0.jfif";